/**
 * WHO HOLDS A CASE, in words (moved here from the case drawer on 16 Oct 2026 so the queue's Claimed by
 * column reads it the same way; William, 8:52 PM: "when claimed goes in the main queue with the user name
 * (make sure we ahve a column for this in teh main queue)").
 *
 * The holder is `assignedTo` (a claim sets it, an Unclaim clears it). The operator stamp names whoever
 * touched the case last (an Unclaim stamps the person who pressed it), so its name is used only when it is
 * the holder's own; otherwise the name is read off the holder's address.
 *
 * NO em dashes (house voice rule). ASCII hyphens only.
 */

/** "sherry.east@claridynamics.com" -> "Sherry East": a holder's name read off the address. */
export function nameFromAddress(address: string): string {
  const local = address.split('@')[0] ?? '';
  return local.split(/[._-]+/).filter(Boolean).map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ') || address;
}

export interface HolderFields {
  assignedTo?: string | undefined;
  operatorName?: string | undefined;
  operatorEmail?: string | undefined;
}

/** The holder's name, or '' when nobody has claimed the case. */
export function claimHolderName(r: HolderFields): string {
  const holder = (r.assignedTo ?? '').trim();
  if (!holder) return '';
  if ((r.operatorEmail ?? '').toLowerCase() === holder.toLowerCase() && r.operatorName) return r.operatorName;
  return nameFromAddress(holder);
}
